export default __webpack_public_path__ + "bb167dce20a798be75720f458e35f392.svg";